import { useEffect, useMemo, useRef, useState, createRef } from "react";
import { useDispatch } from "react-redux";
import { changeShowNavigationBar } from "../store/components";
import MainPane from "../general/MainPane";
import GeneralAuthentication from "../general/GeneralAuthentication";
import AuthBrokerProspect from "../general/AuthBrokerProspect";
import CheckForInvalidLink from "../general/CheckForInvalidLink";
import HelpOrTip from "../components/HelpOrTip";
import { TwoHeading } from "../general/TwoHeading";
import * as theme from "../theme";
import Navigation from "./Navigation";
import PerfectScrollbar from "react-perfect-scrollbar";
import TwoPanesPanel from "../general/TwoPanesPanel";
import manualImg from "../logos/common/manual_image.png";
// import PerfectScrollbar from "react-perfect-scrollbar";

const ProspectZoomLeftPane = (props) => {
  const targetedDiv = useRef();
  const secondDiv = useRef();
  const dispatch = useDispatch();
  const nav3 = useRef(null);
  //const navArr = useMemo(() => Array(20).fill(0).map(i=> createRef()))
  var navArr = props.navArr
  //const navArr = Array(20).fill(0).map(i=> createRef())
  // backgroundColor: "rgb(214, 218, 231)", border: "thick ridge rgb(246, 249, 252)",
  const styleDisplayNone = {display:'block', display: 'flex', flexFlow: 'column', gap:'9px', borderRadius: "16px", pointer: "cursor" , listStyleType: "none" } //{'display': 'none'}
  const [ hoverStyle, sethoverSyle] = useState(styleDisplayNone) 
  const [hoverNum, sethoverNum] = useState(false)
  const labelStyle = {width: '100%'}
  
  return (
    <div style={{marginLeft:"1%", height:"90vh"}}>
    <PerfectScrollbar>
          <div style={{ display:'flex', flexFlow:'column' }}>
            <label idx="21" ref={navArr[21]} >Manual</label>
            <a href="https://www.canva.com/design/DAG1BlChWSo/WtUwxEpV7LxvMhyZz9jYWw/view?utm_content=DAG1BlChWSo&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h69f0e7ca15" target="_blank" rel="noopener noreferrer">
            <img src={manualImg} width="940" height="640"  frameBorder="0" />
            </a>
          </div>
          <div>
            <label style={labelStyle} idx="0" ref={navArr[0]}>How to Find the Right Insurance Application for your Client</label>
            <iframe src="https://scribehow.com/embed/How_to_Find_the_Right_Insurance_Application_for_your_Client__YyFt2CdtTma5gHecq1WLBg" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle}>How to Complete an Application in Quotey</label>
            <label style={labelStyle} idx="1" ref={navArr[1]}>Step 1: General Business Information </label>
            <iframe src="https://scribehow.com/embed/How_to_Complete_an_Application_in_Quotey__Step_1_General_Business_Information__KPqasrOlQ4--cIhC4Lguvg" width="940" height="640"  frameBorder="0"></iframe>

            <label style={labelStyle} idx="2" ref={navArr[2]}>Step 2: Operations </label>
            <iframe src="https://scribehow.com/embed/How_to_Complete_an_Application_in_Quotey__Step_2_Operations__n2RGawEnTPmLLS-gsMQMrg" width="940" height="640"  frameBorder="0"></iframe>
            
            <label style={labelStyle} idx="3" ref={navArr[3]}>Step 3: Locations</label>
            <iframe src="https://scribehow.com/embed/How_to_Complete_an_Application_in_Quotey__Step_3_Locations__hoTycuj8SzG_HtSQtG3Ckg" width="940" height="640"  frameBorder="0"></iframe>
            
            <label style={labelStyle} idx="4" ref={navArr[4]}>Step 4: Claims </label>
            <iframe src="https://scribehow.com/embed/How_to_Complete_an_Application_in_Quotey__Step_4_Claims__6OkVb9psS8WJEwqLpVvbDw" width="940" height="640"  frameBorder="0"></iframe>
            
            <label style={labelStyle} idx="5" ref={navArr[5]}>Step 5: Policy Limits </label>
            <iframe src="https://scribehow.com/embed/How_to_Complete_an_Application_in_Quotey__Step_5_Policy_Limits__hK1Hn90-TJWC3YQXHyyJ7g" width="940" height="640"  frameBorder="0"></iframe>
          
            <label style={labelStyle} idx="6" ref={navArr[6]}>Step 6: Other Information</label>
            <iframe src="https://scribehow.com/embed/How_to_Complete_an_Application_in_Quotey__Step_6_Other_Information__-OhaZyLSQoW-N8JMkyn-Kg" width="940" height="640"  frameBorder="0"></iframe>

          </div>

          <div ref={navArr[7]} idx="7" className="nav3">
            <label style={labelStyle} >How to get a Quote through Live Markets on Quotey</label>
            <iframe src="https://scribehow.com/embed/How_to_get_a_Quote_through_Live_Markets_on_Quotey__I7c_w59zSQWIxT7KRef7-Q" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle} idx="8" ref={navArr[8]}>How to Use the Hand Off to Client Feature </label>
            <iframe src="https://scribehow.com/embed/How_to_Use_the_Hand_Off_to_Client_Feature__3ScZZl4vTM-qOQyl-IEucw" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle} idx="9" ref={navArr[9]}>How to Compare Products on Quotey</label>
            <iframe src="https://scribehow.com/embed/How_to_Compare_Products_on_Quotey__elRG0ABqQrupw7VBBytrkw" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle} idx="10" ref={navArr[10]}>How to Add/Edit an External Insurer Quote + Use the Insurer Package Pre-fill Function</label>
            <iframe src="https://scribehow.com/embed/How_to_AddEdit_an_External_Insurer_Quote__Use_the_Insurer_Package_Pre-fill_Function__pYKmWlfjQwOg5_4-fe55Yg" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle} idx="11" ref={navArr[11]}>How to Create a Client Presentation</label>
            <iframe src="https://scribehow.com/embed/How_to_Create_a_Client_Presentation__knqhnKOcTf6Z0cM72PQvBQ" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle} idx="12" ref={navArr[12]}>How to Create a Bind Request</label>
            <iframe src="https://scribehow.com/embed/How_to_Create_a_Bind_Request__EiAoqAM1QB25de2a7lBYWA" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle} idx="13" ref={navArr[13]} >How to Update a Client’s Application Status on Quotey</label>
            <iframe src="https://scribehow.com/embed/How_to_Update_a_Clients_Application_Status_on_Quotey__LCE9rskSR-eQaOJUA_3Qhw" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle} idx="14" ref={navArr[14]} >How to Upload Documents in Quotey</label>
            <iframe src="https://scribehow.com/embed/How_to_Upload_Documents_in_Quotey__vG6oPZpvSHOfXAMV0NAJxw" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle} idx="15" ref={navArr[15]} >How to Attach a Document to your Client's Submission</label>
            <iframe src="https://scribehow.com/embed/How_to_Attach_a_Document_to_your_Clients_Submission__i_glcjr1SVSvKcq-8oYH_w" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle} idx="16" ref={navArr[16]} >How to Upload an Equipment Schedule in Quotey</label>
            <iframe src="https://scribehow.com/embed/How_to_Upload_an_Equipment_Schedule_in_Quotey__R9IX9cAySzqql3Nox_NMkg" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle} idx="17" ref={navArr[17]} >How to Locate and Download a Client's Application in Quotey</label>
            <iframe src="https://scribehow.com/embed/How_to_Locate_and_Download_a_Clients_Application_in_Quotey__OAEOxPvGQoGdysRC624Rcw" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle} idx="18" ref={navArr[18]} >How to Create a Binder Letter in Quotey</label>
            <iframe src="https://scribehow.com/embed/How_to_Create_a_Binder_Letter_in_Quotey__Fp0uPrajRByRGnOHOoVoxA" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle} idx="19" ref={navArr[19]} >How to Add an Additional Insured or Loss Payee to a policy on Quotey</label>
            <iframe src="https://scribehow.com/embed/How_to_Add_an_Additional_Insured_or_Loss_Payee_to_a_policy_on_Quotey__7pA3fIQ4RG-DzsUwLxJvWw" width="940" height="640"  frameBorder="0"></iframe>

          </div>
          <div>
            <label style={labelStyle} idx="20" ref={navArr[20]} >How to Create a Certificate in Quotey</label>
            <iframe src="https://scribehow.com/embed/How_to_Create_a_Certificate_in_Quotey__IAa5ZiUAT9OLBTL4UPRkOg" width="940" height="640"  frameBorder="0"></iframe>

          </div>
    </PerfectScrollbar>
    </div>
  )
}

const ProspectZoomRightPane = (props) => {
  const targetedDiv = useRef();
  const secondDiv = useRef();
  const dispatch = useDispatch();
  const nav3 = useRef(null);
  //const navArr = useMemo(() => Array(20).fill(0).map(i=> createRef()))
  var navArr = props.navArr
  //const navArr = Array(20).fill(0).map(i=> createRef())
  // backgroundColor: "rgb(214, 218, 231)", border: "thick ridge rgb(246, 249, 252)",
  const styleDisplayNone = {display:'block', display: 'flex', flexFlow: 'column', gap:'9px', borderRadius: "16px", pointer: "cursor" , listStyleType: "none" } //{'display': 'none'}
  const [ hoverStyle, sethoverSyle] = useState(styleDisplayNone) 
  const [hoverNum, sethoverNum] = useState(-1)
  const labelStyle = {width: '100%'}
  
  return (
    <div>
      <div style={{marginLeft:"2vmin"}}>
        <TwoHeading
          heading1={"Help Topics"}
          fontSize={"3vmin"}
        ></TwoHeading>
      </div>
      <ul style={hoverStyle}>
        <li className="linkStyle" idx="0" style={hoverNum == "0" ? {'fontWeight': 600} :{}} onClick={() => { console.log(navArr); navArr[0].current?.scrollIntoView({behaviour:'smooth'})}}>How to Find the Right Insurance Application for your client</li>
        <li className="">
          How to Complete an Application in Quotey
          <ul style={{listStyleType: "none" }}>
            <li className="linkStyle" idx="1" style={hoverNum == "1" ? {'fontWeight': 600} :{}} onClick={() => navArr[1].current?.scrollIntoView({behaviour:'smooth'})}>Step 1: General Business Information</li>
            <li className="linkStyle" idx="2" style={hoverNum == "2" ? {'fontWeight': 600} :{}} onClick={() => navArr[2].current?.scrollIntoView({behaviour:'smooth'})}>Step 2: Operations</li>
            <li className="linkStyle" idx="3" style={hoverNum == "3" ? {'fontWeight': 600} :{}} onClick={() => navArr[3].current?.scrollIntoView({behaviour:'smooth'})}>Step 3: Locations</li>
            <li className="linkStyle" idx="4" style={hoverNum == "4" ? {'fontWeight': 600} :{}} onClick={() => navArr[4].current?.scrollIntoView({behaviour:'smooth'})}>Step 4: Claims</li>
            <li className="linkStyle" idx="5" style={hoverNum == "5" ? {'fontWeight': 600} :{}} onClick={() => navArr[5].current?.scrollIntoView({behaviour:'smooth'})}>Step 5: Policy Limits</li>
            <li className="linkStyle" idx="6" style={hoverNum == "6" ? {'fontWeight': 600} :{}} onClick={() => navArr[6].current?.scrollIntoView({behaviour:'smooth'})}>Step 6: Other Information</li>
          </ul>
        </li>
        <li className="linkStyle" idx="7"  style={hoverNum == "7" ? {'fontWeight': 600} :{}} onClick={() => navArr[7].current?.scrollIntoView({behaviour:'smooth'})}>How to get a Quote through Live Markets on Quotey</li>
        <li className="linkStyle" idx="8"  style={hoverNum == "8" ? {'fontWeight': 600} :{}} onClick={() => navArr[8].current?.scrollIntoView({behaviour:'smooth'})}>How to Use the Hand Off to Client Feature</li>
        <li className="linkStyle" idx="9"  style={hoverNum == "9" ? {'fontWeight': 600} :{}} onClick={() => navArr[9].current?.scrollIntoView({behaviour:'smooth'})}>How to Compare Products on Quotey</li>
        <li className="linkStyle" idx="10" style={hoverNum == "10" ? {'fontWeight': 600} :{}} onClick={() => navArr[10].current?.scrollIntoView({behaviour:'smooth'})}>How to Add/Edit an External Insurer Quote + Use the Insurer Package Pre-fill Function</li>
        <li className="linkStyle" idx="11" style={hoverNum == "11" ? {'fontWeight': 600} :{}} onClick={() => navArr[11].current?.scrollIntoView({behaviour:'smooth'})}>How to Create a Client Presentation</li>
        <li className="linkStyle" idx="12" style={hoverNum == "12" ? {'fontWeight': 600} :{}} onClick={() => navArr[12].current?.scrollIntoView({behaviour:'smooth'})}>How to Create a Bind Request</li>
        <li className="linkStyle" idx="13" style={hoverNum == "13" ? {'fontWeight': 600} :{}} onClick={() => navArr[13].current?.scrollIntoView({behaviour:'smooth'})}>How to Update a Client’s Application Status on Quotey</li>
        <li className="linkStyle" idx="14" style={hoverNum == "14" ? {'fontWeight': 600} :{}} onClick={() => navArr[14].current?.scrollIntoView({behaviour:'smooth'})}>How to Upload Documents in Quotey</li>
        <li className="linkStyle" idx="15" style={hoverNum == "15" ? {'fontWeight': 600} :{}} onClick={() => navArr[15].current?.scrollIntoView({behaviour:'smooth'})}>How to Attach a Document to your Client's Submission</li>
        <li className="linkStyle" idx="15" style={hoverNum == "16" ? {'fontWeight': 600} :{}} onClick={() => navArr[16].current?.scrollIntoView({behaviour:'smooth'})}>How to Upload an Equipment Schedule in Quotey</li>
        <li className="linkStyle" idx="16" style={hoverNum == "17" ? {'fontWeight': 600} :{}} onClick={() => navArr[17].current?.scrollIntoView({behaviour:'smooth'})}>How to Locate and Download a Client's Application in Quotey</li>
        <li className="linkStyle" idx="17" style={hoverNum == "18" ? {'fontWeight': 600} :{}} onClick={() => navArr[18].current?.scrollIntoView({behaviour:'smooth'})}>How to Create a Binder Letter in Quotey</li>
        <li className="linkStyle" idx="18" style={hoverNum == "19" ? {'fontWeight': 600} :{}} onClick={() => navArr[19].current?.scrollIntoView({behaviour:'smooth'})}>How to Add an Additional Insured or Loss Payee to a policy on Quotey</li>
        <li className="linkStyle" idx="19" style={hoverNum == "20" ? {'fontWeight': 600} :{}} onClick={() => navArr[20].current?.scrollIntoView({behaviour:'smooth'})}>How to Create a Certificate in Quotey</li>
      </ul>
    </div>
  )
}

const HelpfulVideosNew = () => {
  const targetedDiv = useRef();
  const secondDiv = useRef();
  const dispatch = useDispatch();
  const nav3 = useRef(null);
  const navArr = useMemo(() => Array(21).fill(0).map(i=> createRef()))
  //const navArr = Array(20).fill(0).map(i=> createRef())
  // backgroundColor: "rgb(214, 218, 231)", border: "thick ridge rgb(246, 249, 252)",
  const styleDisplayNone = {display:'block', display: 'flex', flexFlow: 'column', gap:'9px', borderRadius: "16px", pointer: "cursor" , listStyleType: "none" } //{'display': 'none'}
  const [ hoverStyle, sethoverSyle] = useState(styleDisplayNone) 
  const [hoverNum, sethoverNum] = useState(false)
  const labelStyle = {width: '100%'}
  
  /* 
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          //do your actions here
          console.log('It works!')
          console.log(entry.target);
          var idx = entry.target?.getAttribute('idx');
          //console.log(idx)
            if(idx && idx != hoverNum){
              sethoverNum(idx)
              console.log("set: ", idx)
            }
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1
      }
    );

    navArr.map(x => { if(x.current) observer.observe(x.current)} )
    //observer.observe();
    
  }, [navArr, navArr[0] ]);
 */
  const [scrollPosition, setPosition] = useState({ scrollX: 0, scrollY: 0 })
  const [scrolling, setScrolling] = useState(false);
  const [scrollTop, setScrollTop] = useState(0)
  const [topCss, setTopCss] = useState('auto')
  useEffect(() => {
    const onScroll = e => {
      setScrollTop(e.target.documentElement.scrollTop);
      setScrolling(e.target.documentElement.scrollTop > scrollTop);
      if(scrollTop < 25){
        setTopCss('auto')
      }else{
        setTopCss('0px')
      }
    };
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);


  return (
    <GeneralAuthentication>
      <MainPane hideHelpOrTip={true}>
        <TwoPanesPanel
          myquotesscreen={true}
          myquotesleftpane={
            <ProspectZoomRightPane prospectid={"TES"} navArr={navArr}></ProspectZoomRightPane>
          }
          myquotesrightpane={
            <ProspectZoomLeftPane prospectid={"TES"} navArr={navArr}></ProspectZoomLeftPane>
          }
          rightPaneWidth={"70%"}
          leftPaneWidth={"25%"}
        ></TwoPanesPanel>
      </MainPane>   
    </GeneralAuthentication>
  );
};

export default HelpfulVideosNew;
